import { type ReactNode } from 'react'
import * as Mtds from '@mattilsynet/design/react'

type EmptyStateProps = {
  title?: ReactNode
  description?: ReactNode
  children?: ReactNode
}

export const EmptyState = ({
  title,
  description,
  children
}: EmptyStateProps) => {
  return (
    <Mtds.Grid data-gap='2'>
      {title && (
        <Mtds.Heading as='h2' data-size='xs'>
          {title}
        </Mtds.Heading>
      )}
      {description && <Mtds.Muted>{description}</Mtds.Muted>}
      {children}
    </Mtds.Grid>
  )
}
